import { useGetAdditionalEmailFromMyExamCard } from '@exam-room/graphql';
import { useParams, useNavigate } from 'react-router-dom';

import { LoadingSpinner } from '../../../../components';
import { useGetExamEventSettings } from '../../../../hooks';
import { useAuth } from '../../../../providers';
import { PATHS } from '../../../constants';
import { LogoutButtonWithCountdown } from '../../containers';
import { ExamResultCard, ExamineeCertificateInfoCard } from '../components';

function ExamCompletedCard() {
  // TODO: get examCardId from provider
  const { examCardId } = useParams();
  const { user, logout } = useAuth();

  const navigate = useNavigate();

  const { isLoading: isGetResultSettingsLoading, settings } = useGetExamEventSettings({
    cardId: examCardId as string,
  });
  const {
    loading: isGetAdditionalEmailFromMyExamCardLoading,
    data: getAdditionalEmailFromMyExamCardData,
  } = useGetAdditionalEmailFromMyExamCard();

  const email = user?.email;
  const additionalEmail = getAdditionalEmailFromMyExamCardData?.erGetMyExamCard.additionalEmail;

  const examResultSettings = settings.result;

  const shouldDisplayCertificateInfo = examResultSettings.hasCertificate;

  const handleLogout = async () => {
    await logout();
    navigate(PATHS.Home);
  };

  const isLoading = isGetResultSettingsLoading || isGetAdditionalEmailFromMyExamCardLoading;

  if (isLoading) {
    return (
      <div className='grid h-dvh w-screen place-items-center'>
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <ExamResultCard variant='submitted' delayedDays={examResultSettings.delayedDays}>
      {shouldDisplayCertificateInfo ? (
        <ExamineeCertificateInfoCard email={email} additionalEmail={additionalEmail} />
      ) : null}
      <LogoutButtonWithCountdown className='w-full' onLogout={handleLogout} countdownTime={120} />
    </ExamResultCard>
  );
}

export default ExamCompletedCard;
